import axios from "@/api/axiosInstance";

export const removeCompanyPermissionOverride = async (
  companyUuid: string,
  overrideId: number,
): Promise<void> => {
  await axios.delete(
    `/api/private/admin/companies/${companyUuid}/permission-overrides/${overrideId}`,
  );
};
